import React from 'react';
import { Typography as MUITypography, TypographyProps as MUITypographyProps } from '@material-ui/core';
import { createFluidTypography } from '../../theme/material/helpers';

interface TypographyProps extends MUITypographyProps {
  minFontSize?: number;
  maxFontSize?: number;
}

const Typography: React.FC<TypographyProps> = ({ minFontSize, maxFontSize, ...rest }) => {
  const applyFontFluid =
    minFontSize !== undefined && maxFontSize !== undefined
      ? createFluidTypography(minFontSize, maxFontSize)
      : minFontSize !== undefined
      ? createFluidTypography(minFontSize, minFontSize)
      : maxFontSize !== undefined
      ? createFluidTypography(maxFontSize, maxFontSize)
      : {};

  return (
    <MUITypography
      {...rest}
      style={{
        ...applyFontFluid,
        ...rest.style,
      }}
    />
  );
};

export default Typography;
